// removed by extract-text-webpack-plugin
module.exports = {"Hero":"src-components-Destination-Hero----Hero-module---Hero---39f9i","Hero__Wrapper":"src-components-Destination-Hero----Hero-module---Hero__Wrapper---2_xNt","Hero__Title":"src-components-Destination-Hero----Hero-module---Hero__Title---ZH3s-","Hero__Title__Reduced":"src-components-Destination-Hero----Hero-module---Hero__Title__Reduced---1HIGC","Hero__Title__Academy":"src-components-Destination-Hero----Hero-module---Hero__Title__Academy---TW1n3","Hero__Info":"src-components-Destination-Hero----Hero-module---Hero__Info---3HfGE"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Destination/Hero/Hero.module.scss
// module id = 307
// module chunks = 116453730430729 163216947426909